import { Observable } from 'rxjs';
import { APPLICATIONS_TYPES } from '../../helpers/applications-types';
import { InjectionToken } from '@angular/core';

export const APPLICATIONS_SERVICE_TOKEN = new InjectionToken<IApplicationsService>('IApplicationsService');

interface IApplicationsService {
  getData(): Observable<IApplication[]>;
}

interface ResponseData {
  data: IApplication[];
  measure: number;
  measure_with_boot: number;
}

interface IApplication {
  id: number;
  name: string;
  logo?: string;
  domain: string;
  type: keyof typeof APPLICATIONS_TYPES;
  active: boolean;
  created_at: number;
  path_suffix?: string;
}

export { IApplicationsService, ResponseData, IApplication };
